// @flow
import React, { type Node } from 'react';
import Loader from 'angieslist-app-platform/lib/browser/Loader';
import onePlatformRedirectService from '../../modules/common/onePlatformRedirectService';

type Props = {
  pathname: string,
  children: Node,
};

type State = {
  checking: boolean,
};

const LEADS_INBOX_PATH = /^\/app\/h\/inbox\/([^/?]+)\/?$/;

export function leadsInboxServiceProviderId(pathname: string): ?string {
  const match = LEADS_INBOX_PATH.exec(pathname || '');
  if (!match) return null;
  return decodeURIComponent(match[1]);
}

const fullPageLoader = (
  <div
    id="one-platform-redirect-loader"
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <i className="icon icon-load icon-spin icon-3x text-primary" />
  </div>
);

export class OnePlatformInboxGate extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.mounted = true;
    this.requestId = 0;
    this.state = {
      checking: Boolean(leadsInboxServiceProviderId(props.pathname)),
    };
  }

  componentWillMount() {
    const serviceProviderId = leadsInboxServiceProviderId(this.props.pathname);
    if (!serviceProviderId || typeof window === 'undefined') return;
    this.requestRedirect(serviceProviderId);
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.pathname === this.props.pathname) return;
    const serviceProviderId = leadsInboxServiceProviderId(nextProps.pathname);
    if (!serviceProviderId) {
      this.requestId += 1;
      if (this.state.checking) this.setState({ checking: false });
      return;
    }
    this.setState({ checking: true });
    this.requestRedirect(serviceProviderId);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  requestRedirect(serviceProviderId: string) {
    const requestId = this.requestId + 1;
    this.requestId = requestId;
    const pagePath = `${window.location.pathname}${window.location.search}`;
    onePlatformRedirectService.getOnePlatformRedirect(serviceProviderId, pagePath)
      .then((redirectUrl) => {
        if (!this.mounted || this.requestId !== requestId) return;
        if (redirectUrl) {
          window.location.assign(redirectUrl);
          return;
        }
        this.setState({ checking: false });
      })
      .catch(() => {
        if (!this.mounted || this.requestId !== requestId) return;
        this.setState({ checking: false });
      });
  }

  mounted: boolean;
  requestId: number;

  render(): Node {
    return (
      <Loader loading={this.state.checking} element={fullPageLoader}>
        {this.props.children}
      </Loader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/browser/OnePlatformInboxGate.js